import { render, staticRenderFns } from "./NewProvider.vue?vue&type=template&id=4856c202&scoped=true&"
import script from "./NewProvider.vue?vue&type=script&lang=js&"
export * from "./NewProvider.vue?vue&type=script&lang=js&"
import style0 from "./NewProvider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewProvider.vue?vue&type=style&index=1&id=4856c202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856c202",
  null
  
)

export default component.exports